import { keyframes, styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

export const LOADER_ACCENT_COLOR = "#0077A8";

export const bounceKeyframes = keyframes`
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.5; }
  40% { transform: scale(1); opacity: 1; }
`;

export const LoaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gap',
})(({ gap }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: gap || 8,
}));

export const LoaderContainerHorizontal = styled(LoaderContainer)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
}));

export const DotContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'dotSize' && prop !== 'delay',
})(({ theme, dotSize, delay }) => ({
  width: dotSize || 8,
  height: dotSize || 8,
  borderRadius: '50%',
  backgroundColor: LOADER_ACCENT_COLOR,
  animation: `${bounceKeyframes} 1.4s ease-in-out infinite both`,
  animationDelay: `${delay}s`,
}));

export const LoadingText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})(({ theme, fontSize }) => ({
  color: LOADER_ACCENT_COLOR,
  fontSize: fontSize || 14,
}));

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
}));

export const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'linearWidth',
})(({ linearWidth }) => ({
  width: linearWidth,
  borderRadius: 4,
  backgroundColor: "rgba(0, 119, 168, 0.15)",
  "& .MuiLinearProgress-bar": {
    borderRadius: 4,
    backgroundColor: LOADER_ACCENT_COLOR,
  },
}));

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: LOADER_ACCENT_COLOR,
}));
